module.exports = __webpack_public_path__ + "media/images/logo-white-dd076e9036f2e555dd44a1f78abf1ee2.png";